import { useState } from 'react';
import { api, formatApiError } from '@/lib/api';
import { Wordmark } from '@/components/yunti/Wordmark';

export function Login({ onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const { data } = await api.post('/auth/login', { email, password });
      onSuccess(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    'w-full px-4 py-3 bg-white border border-yunti-ink/20 text-sm focus:border-yunti-purple focus:outline-none rounded-none';
  const labelCls = 'block text-xs font-mono uppercase tracking-wider text-yunti-ink/70 mb-1';

  return (
    <div className="min-h-screen bg-yunti-ground flex items-center justify-center px-6" data-testid="admin-login">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="text-3xl font-display uppercase tracking-tight text-yunti-ink">
            <Wordmark text="YUNTI" />
          </div>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-yunti-purple mt-2">Site Manager</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-4 bg-white border border-yunti-ink/10 p-6" data-testid="admin-login-form">
          <div>
            <label className={labelCls} htmlFor="admin-email">Email</label>
            <input
              id="admin-email"
              type="email"
              required
              className={inputCls}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className={labelCls} htmlFor="admin-password">Password</label>
            <input
              id="admin-password"
              type="password"
              required
              className={inputCls}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
            />
          </div>
          {error && (
            <p className="text-xs font-mono text-red-700 bg-red-50 border border-red-200 px-3 py-2" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full py-3.5 bg-yunti-ink text-white text-xs font-mono uppercase tracking-[0.2em] hover:bg-yunti-purple transition-colors font-semibold disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {busy ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
